<template>
    <div>
        <breadCrumb 
            :icon="'fa-user-cog'"
            :category="$t(`sideNav.navSalonMenu`)"
            :subCategory="$t(`subMenu.salon_menu_service`)"
            :subSubCategory="''">
        </breadCrumb>
        <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
            <li class="nav-item" v-for="t in tab" :key="t.id">
                <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="renderTabs(t.id)">{{t.text}}</a>
            </li>
        </ul>
        <div class="tab-content mt-5">
            <serviceList ref="serviceList" :class="{'active': selectedTab === 'main'}" class="tab-pane"></serviceList>
            <serviceSubCategoryList ref="serviceSubCategoryList" :class="{'active': selectedTab === 'sub'}" class="tab-pane"></serviceSubCategoryList>
        </div>
    </div>
</template>

<script>
import BreadCrumb from './../../Bread_Crumb'
import ServiceList from './Service_List'
import ServiceSubCategoryList from './Service_SubCategoryList'
import {setSalonMenuTabLabel} from './../../../../assets/js/dashboard/dashboard'

export default {
    name: 'menuService',
    components:{
        ServiceList, ServiceSubCategoryList, BreadCrumb
    },
    data(){
        return{
            tab: [], selectedTab: 'main'
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setTabLabel()
        }
    },
    methods:{
        renderTabs(id){
            this.selectedTab = id;
            this.$refs.serviceList.addServiceToggle = false;
            this.$refs.serviceSubCategoryList.addSubToggle = false;
        },
        setTabLabel(){
            this.tab = setSalonMenuTabLabel(this.$i18n.t('subMenu.salon_menu_service'), this.$i18n.t('header.subCategory', {'item': this.$i18n.t('subMenu.salon_menu_service')}))
        }
    },
    mounted(){
        let $vm = this
        $vm.setTabLabel()
    }
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
</style>